import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FinancialPerformanceReport from '../../../components/FinancialPerformanceReport/FinancialPerformanceReport';
import { selectCurrentVenue } from '../../../redux/slices/currentUserSlice';
import { selectSelectedWeek } from '../../../redux/violationsReport/violationsReportSlice';
import { selectDailyTicketsByPeriod } from '../../../redux/dailyTickets/dailyTicketsSlice';
import { fetchDailyTicketsByPeriod } from '../../../redux/dailyTickets/dailyTicketsThunks';
import {
  FinanceReportContainer,
  ReportsFinanceContent,
  ReportsFinanceTableContainer,
  TitleReport,
} from './FinanceReports.styles';

const FinanceReport = () => {
  const dispatch = useDispatch();
  const venueId = useSelector(selectCurrentVenue).id;
  const selectedWeek = useSelector(selectSelectedWeek);
  const dailyTickets = useSelector(selectDailyTicketsByPeriod);

  useEffect(() => {
    if (venueId && selectedWeek) {
      dispatch(fetchDailyTicketsByPeriod({ vid: venueId, selectedWeek }));
    }
  }, [dispatch, venueId, selectedWeek]);

  return (
    <FinanceReportContainer>
      <ReportsFinanceContent>
        <ReportsFinanceTableContainer>
          <TitleReport variant="bodyRegular">Net Sales vs Labor Cost</TitleReport>
          <FinancialPerformanceReport dailyTickets={dailyTickets} />
        </ReportsFinanceTableContainer>
      </ReportsFinanceContent>
    </FinanceReportContainer>
  );
};

export default FinanceReport;
